exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.configurar-Transbank .estilo-grilla,\n#gridComponent {\n  height: auto !important;\n  margin-bottom: 50px;\n}\n", ""]);

// exports
